'use client'

/**
 * Carries the SERVER-DECIDED Morning Brief promo verdict (src/lib/email/briefPromo.ts) into <DailyBriefPromo/>, so the
 * card is in the first paint or not at all instead of inserting itself above the page after three fetches (register
 * daily-brief-promo-pops-in-above-chart-1105). Same shape as InitialAccessProvider.
 *
 * ⚠ Its own file, not an export of DailyBriefPromo: the root layout mounts this provider on every page, and importing
 * it from the card would pull the card into every page's client bundle.
 */

import { createContext, useContext } from 'react'
import type { BriefPromoInitial } from '@/lib/email/briefPromo'

const BriefPromoInitialContext = createContext<BriefPromoInitial | null>(null)

export function BriefPromoInitialProvider({ value, children }: { value: BriefPromoInitial | null; children: React.ReactNode }) {
  return <BriefPromoInitialContext.Provider value={value}>{children}</BriefPromoInitialContext.Provider>
}

/** null when no verdict was provided: the card then decides after mount, exactly as it always did. */
export function useBriefPromoInitial(): BriefPromoInitial | null {
  return useContext(BriefPromoInitialContext)
}
